import React, { useState, useEffect } from "react";
import { createChef, getCuisines, getCommission, createChefBasic } from "../../../../actions/restaurantAction";
import BottomTabNav from "../../customs/BottomTabNav";
import Input from '../../customs/Input'
import SelectOption from "../../customs/SelectOption";
import Loading from '../../../../utilities/Loading'
import { useDispatch } from "react-redux";
import MultiSelectOption from "../../customs/MultiSelectOption";


export default function BasicInfo(props) {
  const [cuisines, setCuisines] = useState([]);
  const [commission, setCommission] = useState(0)
  const [chef, setChef] = useState({});
  const [loaded, setLoaded] = useState(false)

  const dispatch = useDispatch()

  const onChangeText = ({ target }) => {
    setChef(prevState => ({ ...prevState, [target.name]: target.value }));
  };

  const onChangeCuisine = (list) => {
    const cuisineArray = list.map(item => item.value);
    setChef(prevState => ({ ...prevState, cuisine_type: cuisineArray }));
  }

  const fetchCuisines = async () => {
    const cuisinesFromData = await getCuisines()
    const cuisinesArray = [{ name: "Choose an option", value: '' }, ...cuisinesFromData.map(item => ({ name: item.cuisineName, value: item.cuisineName }))]
    setCuisines(cuisinesArray)
    setLoaded(true)
  }

  useEffect(() => {
    fetchCuisines()
  }, [])

  useEffect(() => {
    let isComponentMounted = true;
    const fetchCommission = async () => {
      const commission = await getCommission();
      if (isComponentMounted) {
        setCommission(commission);
      }
    };
    fetchCommission();
    return () => {
      isComponentMounted = false;
    };
  }, []);


  const handler = async () => {
    await dispatch(createChefBasic(chef));
  }

  if (loaded) {
    return (
      <fieldset>
        <div className="row mt-2">
          <div className="col-4">
            <Input label="restaurant name"
              required={true}
              name="restaurant_name"
              type="text"
              handler={onChangeText} />
            <Input label="owner name"
              required={true}
              name="owner_name"
              type="text"
              handler={onChangeText} />
            <Input label="City"
              required={true}
              name="city"
              type="text"
              handler={onChangeText} />
            <Input label="country"
              required={true}
              name="country"
              type="text"
              handler={onChangeText} />
          </div>
          <div className="col-4">
            <Input label="phone number"
              required={true}
              name="phone"
              type="text"
              handler={onChangeText} />

            <Input label="address line 1"
              required={true}
              name="locality"
              type="text"
              handler={onChangeText} />

            <Input label="state"
              required={true}
              name="states"
              type="text"
              handler={onChangeText} />

            <Input label="commission"
              required={true}
              name="commission"
              defaultValue={commission}
              disabled={true}
              type="text"
              handler={onChangeText} />
          </div>

          <div className="col-4">
            <Input label="email id"
              required={true}
              name="email"
              type="text"
              handler={onChangeText} />
            <Input label="address line 2"
              required={false}
              name="addressLine2"
              type="text"
              handler={onChangeText} />

            <Input label="postal code"
              required={true}
              name="postal_code"
              type="text"
              handler={onChangeText} />
            <SelectOption
              label="meal type"
              required={true}
              handler={onChangeText}
              name="meal_type"
              values={[
                { name: "Choose an option", value: '' },
                { name: 'Veg', value: 'Veg' },
                { name: 'Non-Veg', value: 'Non-Veg' }
              ]}
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-4">
            <MultiSelectOption
              values={cuisines}
              label="Cuisine"
              name="cuisine_type"
              handler={onChangeCuisine}
              required={true} />
            <SelectOption
              label="meal time"
              name="category"
              handler={onChangeText}
              required={true}
              values={[
                { name: "Choose an option", value: '' },
                { name: 'Both', value: 'Both' },
                { name: 'Lunch', value: 'Lunch' },
                { name: 'Dinner', value: 'Dinner' }]}
            />
            <Input label="Tax"
              required={true}
              name="taxes"
              type="text"
              handler={onChangeText} />
          </div>
          <div className="col-8" aria-rowspan={2}>
            <div className="form-group">
              <label>
                ABOUT <strong className="text-danger">*</strong>
              </label>
              <textarea
                className="form-control form-control-plaintext"
                name="about"
                onChange={(e) => onChangeText(e)}
                rows={8}
              />
            </div>
          </div>
        </div>
        <BottomTabNav currentStep={1} props={props} data={chef} handler={handler} />
      </fieldset>
    );
  } else {
    return <Loading />
  }
}
